import type { IconProps } from './types';

const WarningTriangleIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M20.6663 20H3.33301L11.9997 4L20.6663 20ZM7.66634 17.2H16.333L11.9997 9.2L7.66634 17.2Z" fill={color} />
    </svg>
  );
};

export { WarningTriangleIcon };
